var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tooltip_arrow_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.586 1.414a2 2 0 012.828 0l9.9 9.9L12 22.627.686 11.314l9.9-9.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 1.414a2 2 0 012.828 0l9.9 9.9L12 22.627.686 11.314l9.9-9.9z",
    fill: "#F6F7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.879.707a3 3 0 014.242 0l9.9 9.9-1.414 1.414-9.9-9.9a1 1 0 00-1.414 0L9.879.707zM12 22.627L.686 11.314 12 22.627zM-.02 10.607l9.899-9.9a3 3 0 014.242 0l-1.414 1.414a1 1 0 00-1.414 0l-9.9 9.9-1.414-1.414zm23.334.707L12 22.627l11.314-11.313z",
    fill: "#879CC2",
    mask: "url(#tooltip_arrow_svg__a)"
  })));
}
export default SvgTooltipArrow;